import { useAppStore } from '@/inertia/AppStore';
import { Box, type BoxProps, LinearProgress, List, type ListProps } from '@mui/material';

import { usePanelBreakpoint } from '@/Components/page-ui-editor-2/panel';
import RenderIfVisible from '@/Utility/RenderIfVisible';
import ListViewItem, { listRIVProps } from '../../Catalog/ListItem';
import { SIDEBAR_LIST_ITEM_PREFIX } from '../../Catalog/catalog.utils';
import FormGating from '../../FormGating';
import GridView from '../GridView';
import Bar from './Bar';

import './SideBar.less';

type Props = {
  isFallback?: boolean;
  /**
   * props to be slotted into the SideBar component
   */
  slotProps?: {
    SideBar?: BoxProps;
    List?: ListProps;
  };
};

export const SideBar = (props: Props) => {
  const nodes = useAppStore((state) => state?.catalogNodes);
  const playerNode = useAppStore((state) => state?.playerNode);
  const { isMobile } = usePanelBreakpoint('left');

  const catalogLoadMore = useAppStore((state) => state?.catalogLoadMore);
  const isCatalogLoadingMore = useAppStore((state) => state?.isCatalogLoadingMore);

  return (
    <Box className="SideBar" {...props?.slotProps?.SideBar}>
      <FormGating location="sidebar" />
      <Bar isFallback={props?.isFallback} />
      {isMobile ? (
        <GridView showBar={false} showShare={false} isFallback={props?.isFallback} />
      ) : (
        <div className="ListWrapper FormGating_List">
          <List className="List" {...props?.slotProps?.List}>
            {isCatalogLoadingMore && (
              <LinearProgress sx={{ width: '100%', height: '3px', position: 'sticky', top: '0', zIndex: 100 }} />
            )}
            {nodes?.map((node, idx) => {
              const isMainNode = node?.id === playerNode?.id;
              const isLastNode = idx === nodes?.length - 1;

              const key = `sidebar_item__${encodeURIComponent(window.location.pathname)}_${node?.id}`;

              return (
                <RenderIfVisible
                  key={`sidebar_rif_${node?.id}_${idx}`}
                  onChange={(isVisible: boolean) => {
                    if (isLastNode && isVisible) {
                      catalogLoadMore?.();
                    }
                  }}
                  rootElementClass={`renderIfVisible ${SIDEBAR_LIST_ITEM_PREFIX}${node?.id?.replaceAll('=', '')}`}
                  {...listRIVProps(node, idx)}
                >
                  <ListViewItem key={key} node={node} disabled={isMainNode} idx={idx} isFallback={props?.isFallback} />
                </RenderIfVisible>
              );
            })}
          </List>
        </div>
      )}
    </Box>
  );
};

export default SideBar;
